import log from 'salvo-lite/log'

class SizeGuideScroller {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = JSON.parse(elem.getAttribute('data-size-guide-scroller'))
        this._scrollElement = document.querySelector(this._options.scrollElement)

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('click', () => {
            this._scrollElement.scroll({
                top: 0,
                left: this._scrollElement.scrollLeft + 100,
                behavior: 'smooth'
            })
        })
    }
}

export default SizeGuideScroller



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SizeGuideScroller.js